'use client';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RETAIL_BACKEND, ServiceName } from '@/constants';
import i18n from '@/translations/client-setup';

import { GetTestimonials, Testimonial } from '@/types';

export interface ISearch {
  showroom: string;
  id: string;
}


// Define our single API slice object
export const testimonialApiSlice = createApi({
  // The cache reducer expects to be added at `state.retail` (default is state.api - this is optional)
  reducerPath: 'testimonials',
  baseQuery: fetchBaseQuery({
    baseUrl: RETAIL_BACKEND,
    prepareHeaders: (headers) => {
      headers.set('lang', `${i18n.language}`);
      return headers;
    },
  }),
  tagTypes: ['Testimonials'],
  // The "endpoints" represent operations and requests for this server
  endpoints: (builder) => ({
    // The getTestimonials fetches all customer reviews
    getTestimonials: builder.query<Testimonial[], void>({
      query: () => `${RETAIL_BACKEND}/testimonials/paginated/100/0/{"serviceName":"${ServiceName.ACQUISITION}","status":"PUBLISHED"}/{"sortBy":"response_at","orderBy":"desc"}`,
      providesTags: ['Testimonials'],
      transformResponse: (response: GetTestimonials) => response.data.testimonials,
    }),
  }),
});

// Export the auto-generated hook for the getCarListing and getCarDetails query endpoint
export const { useGetTestimonialsQuery } = testimonialApiSlice;
